import { isString } from "./util";
import { EventProperties } from "./events";
import { UAParser } from "ua-parser-js";

export const isSafari17 = () => {
  const parser = new UAParser();
  const browser = parser.getBrowser();

  if (!browser || !browser.name || !browser.version) {
    return false;
  }

  /* browser name should be safari and major version should be 17 */
  return /safari/i.test(browser.name) && /^17\./.test(browser.version);
};

export const firstContentfulPaintTime = () => {
  if (EventProperties.firstHiddenTime === 0) {
    return null;
  }
  let FCP = 0;
  if (window.performance && window.performance.getEntriesByType) {
    let paints = window.performance.getEntriesByType("paint");
    for (let i = 0; i < paints.length; i++) {
      if ("first-contentful-paint" === paints[i].name) {
        FCP = Math.round(paints[i].startTime);
        return FCP < EventProperties.firstHiddenTime ? FCP : null;
      }
    }
    return null;
  }
  if ("object" === typeof window.chrome && window.chrome.loadTimes) {
    var a = window.chrome.loadTimes();
    if (
      a.requestTime &&
      a.firstPaintTime &&
      window.performance &&
      window.performance.timing
    ) {
      FCP = Math.round(
        1e3 * a.firstPaintTime - window.performance.timing.navigationStart
      );
      return FCP < EventProperties.firstHiddenTime ? FCP : null;
    }
  } else if (
    window.performance &&
    window.performance.timing &&
    ((a = window.performance.timing), a.navigationStart && a.msFirstPaint)
  ) {
    FCP = a.msFirstPaint - a.navigationStart;
    return FCP < EventProperties.firstHiddenTime ? FCP : null;
  }
  return null;
};

export const largestContentfulPaintTime = (
  sendLoadMetrics,
  eventForLCP = () => {}
) => {
  try {
    const updateLCP = (entry) => {
      if (entry.startTime < EventProperties.firstHiddenTime) {
        EventProperties.LCP = Math.round(entry.startTime);
        // send LCP for pages without scroll
        if (sendLoadMetrics) {
          let scrollHeight = document.documentElement.scrollHeight || 0;
          let pageHeight = document.documentElement.clientHeight || 0;
          if (pageHeight >= scrollHeight) {
            eventForLCP();
          }
        }
      }
    };

    const po = new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      entries.forEach((entry) => {
        updateLCP(entry);
      });
    });
    po.observe({ type: "largest-contentful-paint", buffered: true });

    document.addEventListener(
      "visibilitychange",
      function f() {
        if (document.visibilityState === "hidden") {
          document.removeEventListener("visibilitychange", f, true);
          let rec = [];
          if (po.takeRecords) {
            rec = po.takeRecords();
          }
          for (let i = 0; i < rec.length; i++) {
            updateLCP(rec[i], po);
          }
          po.disconnect();
        }
      },
      true
    );
  } catch (e) {}
};

export const netType = () => {
  const a = (navigator.connection || { type: "" }).type;
  return a === undefined ? "" : a;
};

export const getLanguage = () => {
  const a = (
    window.navigator
      ? navigator.language ||
        navigator.userLanguage ||
        navigator.browserLanguage ||
        navigator.systemLanguage
      : ""
  ).toLowerCase();
  return isString(a) ? a : "";
};

export const getJavaEnabled = () => {
  try {
    return navigator.javaEnabled();
  } catch (a) {
    return false;
  }
};

export const getNotificationPermission = () => {
  // The value can be: granted, denied, or default
  // but in the default case the application will act as if permission was denied.
  // see here: https://developer.mozilla.org/en-US/docs/Web/API/Notification/permission_static
  if ("Notification" in window && Notification.permission === "granted") {
    return 1;
  } else {
    return 0;
  }
};

export const isIframe = () => {
  try {
    return window.top !== window.self;
  } catch (error) {
    return false;
  }
};

export const getCookiesEnabled = () => {
  if (navigator.cookieEnabled) return true;
  document.cookie = "cookietest=1";
  const ret = document.cookie.includes("cookietest=");
  document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
  return ret;
};

export const adBlockExists = (Config) => {
  if (Config.adBlockExists) {
    return Config.adBlockExists;
  }

  let fakeAd = document.createElement("div");
  fakeAd.className =
    "textads banner-ads banner_ads ad-unit ad-zone ad-space adsbox";
  fakeAd.style.height = "1px";
  document.body.appendChild(fakeAd);

  Config.adBlockExists = fakeAd.offsetHeight === 0;

  fakeAd.remove();
  fakeAd = null;
  return Config.adBlockExists;
};
